import { render, staticRenderFns } from "./UnidataEditorCorrelatorOptionList.vue?vue&type=template&id=47b77b05&"
import script from "./UnidataEditorCorrelatorOptionList.vue?vue&type=script&lang=js&"
export * from "./UnidataEditorCorrelatorOptionList.vue?vue&type=script&lang=js&"
import style0 from "./UnidataEditorCorrelatorOptionList.vue?vue&type=style&index=0&id=47b77b05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports